import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { NOTIFICATION_MEDIUM, NotificationMedium } from 'models/Notification';
import MailIcon from 'icons/Mail.icon';
import MobileIcon from 'icons/Mobile.icon';
import PlatformNotificationIcon from 'icons/PlatformNotification.icon';

import './NotificationMediumTag.styles.scss';

const LABEL = {
  [NOTIFICATION_MEDIUM.EMAIL]: 'email',
  [NOTIFICATION_MEDIUM.SMS]: 'sms',
  [NOTIFICATION_MEDIUM.PLATFORM]: 'platform',
};

const ICON = {
  [NOTIFICATION_MEDIUM.EMAIL]: MailIcon,
  [NOTIFICATION_MEDIUM.SMS]: MobileIcon,
  [NOTIFICATION_MEDIUM.PLATFORM]: PlatformNotificationIcon,
};

type NotificationMediumTagProps = {
  className?: string;
  type: NotificationMedium;
};

const NotificationMediumTag: React.FC<NotificationMediumTagProps> = (props) => {
  const { className, type } = props;

  const classes = classNames('notification-medium-tag', className);

  const { t } = useTranslation();

  const Icon = ICON[type];
  const label = t(LABEL[type]);

  return (
    <span className={classes}>
      <Icon />
      <span>{label}</span>
    </span>
  );
};

export default NotificationMediumTag;
